import { CardFragmentCommonProps } from "@coworker/apprestructured/src/task-management/components/TaskCard/card-fragments/CardFragment";
import { getByPath } from "@coworker/apprestructured/src/shared/helpers/object.helper";
import { getTypedValue } from "@coworker/apprestructured/src/shared/helpers/schemaValidator";
import { isLoading } from "@coworker/apprestructured/src/task-management/loading";
import LoadingCardFragment from "@coworker/apprestructured/src/task-management/components/TaskCard/card-fragments/LoadingCardFragment/LoadingCardFragment";
import { FixaText } from "@coworker/apprestructured/src/shared/wrappers/FixaText/FixaText";
import { Location } from "@coworker/apprestructured/src/task-management/types/SalesLocation";
import { Trans, useTranslation } from "@coworker/locales";
import styles from "./FailedCriteriaSummaryCardFragment.module.css";
import { CriterionKey } from "@coworker/apprestructured/src/task-management/types/TestBuy";

type FailedCriteriaItem = {
  type: CriterionKey;
  completed: boolean;
  comments?: {
    creator_user_id: string;
    title: string;
    text: string;
    created_at: string;
  }[];
};

export type FailedCriteriaSummaryCardFragmentConfigProps = {
  field: string;
  locationField: string;
};

type FailedCriteriaSummaryCardFragmentProps = {
  configProps: FailedCriteriaSummaryCardFragmentConfigProps;
  commonProps: CardFragmentCommonProps;
};

function FailedCriteriaSummaryCardFragment({
  configProps,
  commonProps,
}: FailedCriteriaSummaryCardFragmentProps) {
  const { field, locationField } = configProps;
  const { task } = commonProps;
  const { t } = useTranslation();

  if (isLoading(task)) {
    return <LoadingCardFragment />;
  }

  const criteriaList = getByPath(task, field) as
    FailedCriteriaItem[] | undefined;

  if (!criteriaList || criteriaList.length === 0) {
    return null;
  }

  const failedCriteriaCount = criteriaList.length;

  const location = getTypedValue<Location>(getByPath(task, locationField));
  const locationText = isLoading(location)
    ? ""
    : location?.slid || location?.custom || "";

  return (
    <FixaText textStyle="Body.M" className={styles["root"]}>
      {locationText ? (
        <>
          <Trans>inString</Trans>{" "}
          <span className={styles["information-location"]}>{locationText}</span>
          {` • ${failedCriteriaCount} ${t("criteraFailedString")}`}
        </>
      ) : (
        `${failedCriteriaCount} ${t("criteraFailedString")}`
      )}
    </FixaText>
  );
}

export default FailedCriteriaSummaryCardFragment;
